/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon32Regular = forwardRef('TextBulletIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M12 7a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H13a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M13 15a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H13Z" }),
        React.createElement("path", { d: "M13 24a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H13Z" }),
        React.createElement("path", { d: "M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
